import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { getConfig, scrollToSection, waLink } from "@/lib/api";

export default function WhatsAppFloat() {
  const [waNumber, setWaNumber] = useState("");

  useEffect(() => {
    getConfig().then((c) => setWaNumber(c.whatsapp_number || ""));
  }, []);

  const label = "Chat with us";

  if (!waNumber) {
    return (
      <motion.button
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.5, duration: 0.5 }}
        onClick={() => scrollToSection("enquiry")}
        data-testid="whatsapp-float-button"
        className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-ragi px-5 py-3.5 text-sm font-bold text-white shadow-2xl shadow-ragi/30 transition-transform hover:scale-105"
      >
        <MessageCircle className="h-5 w-5" /> {label}
      </motion.button>
    );
  }

  return (
    <motion.a
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.5, duration: 0.5 }}
      href={waLink(waNumber, "Hi Kandula Home Foods! I would like to place an order.")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-3.5 text-sm font-bold text-white shadow-2xl shadow-emerald-900/30 transition-transform hover:scale-105"
    >
      <span className="relative flex h-2.5 w-2.5">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white opacity-70" />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-white" />
      </span>
      <MessageCircle className="h-5 w-5" /> {label}
    </motion.a>
  );
}
